import OnboardingWidget from './OnboardingWidget'

export default OnboardingWidget
